//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TrailerBlock',
  props: ['youtubeVideoId', 'withoutPreview'],
  data() {
    return {
      videoWasPlaying: false,
      isFirstClick: false,
    };
  },
  computed: {
    isWithoutPreview() {
      const withoutPreview = this.withoutPreview;

      if (withoutPreview === undefined) return false;
      if (withoutPreview === '') return true;
      return !!withoutPreview;
    },
  },
  methods: {
    ready(event) {
      this.player = event.target;
    },
    playVideo() {
      this.isFirstClick = true;

      clearInterval(this.playVideoInterval);
      if (this.player) {
        this.videoWasPlaying = true;
        this.player.playVideo();
      } else {
        this.playVideoInterval = setInterval(() => {
          this.playVideo();
        }, 1000);
      }
    },
  },
};
